// // ═══════════════════════════════════════════════════════════
// //  FemCare — BookingFlow.jsx
// //  Screens: Type → Recommend → Doctor → Mode → Date/Slot →
// //           Confirm → Payment → Confirmed
// //  All screens driven by dynamic JSON config per type
// //  CSS: BookingFlow.module.css
// // ═══════════════════════════════════════════════════════════

// import React, { useMemo, useState } from "react";
// import styles from "../styles/Bookingflow.module.css";
// import {
//   APPOINTMENT_TYPES,
//   CONSULTATION_MODES,
//   PAYMENT_METHODS,
//   TYPE_CONFIGS,
//   ALL_SLOTS,
//   MANUALLY_DISABLED_SLOTS,
// } from "../config/bookingflow";
// import DigitalHealthFAB from "../components/Digitalhealth";

// // ─────────────────────────────────────────────────────────
// //  SVG Icons
// // ─────────────────────────────────────────────────────────
// const ArrowRight = () => (
//   <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
//   </svg>
// );

// const ArrowLeft = () => (
//   <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
//   </svg>
// );

// const ChevDown = () => (
//   <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
//     <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
//   </svg>
// );

// // ─────────────────────────────────────────────────────────
// //  Shared: Logo
// // ─────────────────────────────────────────────────────────
// const Logo = () => (
//   <div className='flex items-center gap-2'>
//     <img
//       src="/Home/FemCareLogo.svg"
//       alt="femcare"
//       className='h-8 md:h-8 w-auto'
//     />
//   </div>
// );

// // ─────────────────────────────────────────────────────────
// //  Shared: Header
// //  No back button — only Save & Exit (→ "/")
// // ─────────────────────────────────────────────────────────
// function Header({ step, total }) {
//   const pct = Math.round((step / total) * 100);

//   return (
//     <>
//       <div className={styles.header}>
//         <Logo />
//         <a href="/" className={styles.saveExit}>
//           Save &amp; Exit
//         </a>
//       </div>
//       <div className={styles.progressRow}>
//         <span className={styles.stepLabel}>
//           Step {step} of {total}
//         </span>
//         <div className={styles.progressTrack}>
//           <div className={styles.progressFill} style={{ width: `${pct}%` }} />
//         </div>
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  Shared: Radio Dot
// // ─────────────────────────────────────────────────────────
// function Radio({ checked }) {
//   return (
//     <div
//       className={styles.radio}
//       style={
//         checked
//           ? { background: "#6b1a9a", borderColor: "#6b1a9a" }
//           : {}
//       }
//     >
//       {checked && <div className={styles.radioDot} />}
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  Shared: Nav Row
// // ─────────────────────────────────────────────────────────
// function NavRow({ onBack, onNext, nextLabel = "Continue", disabled = false }) {
//   return (
//     <div className={`${styles.navRow} ${onBack ? styles.navRowSpaced : ""}`}>
//       {onBack && (
//         <button className={styles.btnOutline} onClick={onBack}>
//           <ArrowLeft /> Back
//         </button>
//       )}
//       <button className={` btn-primary ${styles.btnPrimary}`} onClick={onNext} disabled={disabled}>
//         {nextLabel} <ArrowRight />
//       </button>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 1 — Appointment Type
// // ─────────────────────────────────────────────────────────
// function Screen1({ onNext, booking, setBooking }) {
//   const [sel, setSel] = useState(booking.type || APPOINTMENT_TYPES[0].id);

//   function handleNext() {
//     setBooking((b) => ({ ...b, type: sel }));
//     onNext();
//   }

//   // Illustration emoji per type
//   const illoMap = { doctor: "👩‍⚕️", pregnancy: "🤰", scan: "🔬", pcos: "🩺" };

//   return (
//     <>
//       <Header step={1} total={7} />
//       <div className={styles.body}>
//         <div>
//           <h1 className={styles.screenTitle}>
//             What type of appointment do you need?
//           </h1>
//           <p className={styles.screenSub}>Select the reason for your visit.</p>

//         </div>
//         <div className={styles.twoCol}>
//           <div>
//             {APPOINTMENT_TYPES.map((t) => (
//               <div
//                 key={t.id}
//                 className={`${styles.optionCard} ${sel === t.id ? styles.selected : ""}`}
//                 onClick={() => setSel(t.id)}
//               >
//                 <div className={styles.optionIcon}>{t.icon}</div>
//                 <div className={styles.optionText}>
//                   <strong>{t.title}</strong>
//                   <span>{t.sub}</span>
//                 </div>
//                 <Radio checked={sel === t.id} />
//               </div>
//             ))}
//           </div>
//           <div className={styles.illoWrap}>
//             {/* <div className={styles.illoBg}>{illoMap[sel] || "👩‍⚕️"}</div> */}
//             <img src="/images/appointment.png" className="h-84" />
//             {/* <div >
//               </div> */}
//           </div>
//         </div>

//         <NavRow onNext={handleNext} nextLabel="Continue" />
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 2 — Recommendation (driven by booking.type)
// // ─────────────────────────────────────────────────────────
// function Screen2({ onNext, onBack, booking }) {
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const rec = cfg.recommendation;

//   return (
//     <>
//       <Header step={2} total={7} />
//       <div className={styles.body}>
//         <div>
//           <h2 className={styles.screenTitle}>Recommended for you</h2>
//           <p className={styles.screenSub}>
//             Based on your selection, we recommend these services.
//           </p>

//         </div>
//         <div className={styles.twoCol}>
//           <div className={styles.recCard}>
//             <div className={styles.recCardHeader}>
//               <div className={styles.recCardIcon}>{rec.icon}</div>
//               <div>
//                 <div className={styles.recCardTitle}>{rec.title}</div>
//                 <div className={styles.recBadge}>{rec.badge}</div>
//               </div>
//             </div>
//             <div className={styles.recCardBody}>
//               <div className={styles.recLabel}>Reason summary</div>
//               <p className={styles.recReason}>{rec.reasonSummary}</p>
//               <div className={styles.recLabel}>Includes</div>
//               <div className={styles.recIncludes}>
//                 {rec.includes.map((item) => (
//                   <div key={item} className={styles.recIncludeItem}>
//                     <span className={styles.recCheck}>✓</span>
//                     {item}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div className={styles.sidePanel}>
//             <div className={styles.sidePanelTitle}>Your Context</div>
//             {Object.entries(rec.context).map(([k, v]) => (
//               <div key={k} className={styles.ctxRow}>
//                 <div className={styles.ctxKey}>{k}</div>
//                 <div className={styles.ctxVal}>{v}</div>
//               </div>
//             ))}
//             <div className={styles.ctxNote}>You can modify this later if needed.</div>
//           </div>
//         </div>

//         <NavRow onBack={onBack} onNext={onNext} />
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 3 — Choose Doctor (driven by booking.type)
// // ─────────────────────────────────────────────────────────
// function Screen3({ onNext, onBack, booking, setBooking }) {
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const doctors = cfg.doctors;
//   const [sel, setSel] = useState(booking.doctorId || doctors[0].id);

//   function handleNext() {
//     setBooking((b) => ({ ...b, doctorId: sel }));
//     onNext();
//   }

//   const selDoc = doctors.find((d) => d.id === sel);

//   return (
//     <>
//       <Header step={3} total={7} />
//       <div className={styles.body}>
//         <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 4 }}>
//           <div>
//             <h2 className={styles.screenTitle}>Choose your doctor</h2>
//             <p className={styles.screenSub}>
//               Select a specialist for your {cfg.recommendation.title}.
//             </p>
//           </div>
//           <div className={styles.filterRow} style={{ marginBottom: 0 }}>
//             <button className={styles.filterBtn}>Filters <ChevDown /></button>
//             <button className={styles.filterBtn}>Sort: Relevance <ChevDown /></button>
//           </div>
//         </div>

//         {doctors.map((d) => (
//           <div
//             key={d.id}
//             className={`${styles.docCard} ${sel === d.id ? styles.selected : ""}`}
//             onClick={() => setSel(d.id)}
//           >
//             {d.recommended && (
//               <div className={styles.docRecBadge}>Recommended</div>
//             )}
//             <div className={styles.docAvatar}>{d.emoji}</div>
//             <div className={styles.docInfo}>
//               <div className={styles.docName}>{d.name}</div>
//               <div className={styles.docTitle}>{d.title}</div>
//               <div className={styles.docMeta}>
//                 <div className={styles.docRating}>
//                   <span className={styles.docStar}>★</span>
//                   {d.rating} ({d.reviews})
//                 </div>
//                 <div className={styles.docExp}>🕐 {d.exp}</div>
//               </div>
//               <div className={styles.docTags}>
//                 {d.tags.map((t) => (
//                   <span key={t} className={styles.docTag}>{t}</span>
//                 ))}
//               </div>
//               <div className={styles.docAvail}>📅 Next available: {d.avail}</div>
//             </div>
//             <div
//               className={styles.radio}
//               style={
//                 sel === d.id
//                   ? { background: "#6b1a9a", borderColor: "#6b1a9a" }
//                   : {}
//               }
//             >
//               {sel === d.id && <div className={styles.radioDot} />}
//             </div>
//           </div>
//         ))}

//         <NavRow onBack={onBack} onNext={handleNext} nextLabel="Continue" />
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 4 — Select Consultation Mode
// // ─────────────────────────────────────────────────────────
// function Screen4({ onNext, onBack, booking, setBooking }) {
//   const [sel, setSel] = useState(booking.mode || CONSULTATION_MODES[0].id);
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const rec = cfg.recommendation;
//   const modeIlloMap = {
//     clinic: "🏥",
//     video: "🎥",
//     phone: "📞",
//   };

//   function handleNext() {
//     setBooking((b) => ({ ...b, mode: sel }));
//     onNext();
//   }

//   return (
//     <>
//       <Header step={4} total={7} />
//       <div className={styles.body}>
//         <div>
//           <h2 className={styles.screenTitle}>Select Consultation Mode</h2>
//           <p className={styles.screenSub}>
//             How would you like to consult? Choose your preferred mode.
//           </p>

//         </div>
//         <div className={styles.twoCol}>
//           <div>
//             {CONSULTATION_MODES.map((m) => (
//               <div
//                 key={m.id}
//                 className={`${styles.optionCard} ${sel === m.id ? styles.selected : ""}`}
//                 onClick={() => setSel(m.id)}
//               >
//                 <div className={styles.optionIcon}>{m.icon}</div>
//                 <div className={styles.optionText}>
//                   <strong>{m.title}</strong>
//                   <span>{m.sub}</span>
//                 </div>
//                 <Radio checked={sel === m.id} />
//               </div>
//             ))}
//           </div>
//           <div className={styles.sidePanel}>
//             <div className={styles.sidePanelTitle}>Your Context</div>
//             {Object.entries(rec.context).map(([k, v]) => (
//               <div key={k} className={styles.ctxRow}>
//                 <div className={styles.ctxKey}>{k}</div>
//                 <div className={styles.ctxVal}>{v}</div>
//               </div>
//             ))}
//             <div className={styles.ctxNote}>You can modify this later if needed.</div>
//           </div>
//         </div>

//         <NavRow onBack={onBack} onNext={handleNext} />
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  Helper: build 7-day date strip
// // ─────────────────────────────────────────────────────────
// function buildDates() {
//   const today = new Date();
//   const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

//   return Array.from({ length: 7 }, (_, i) => {
//     const d = new Date(today);
//     d.setDate(today.getDate() + i);
//     return {
//       day: days[d.getDay()],
//       date: d.getDate(),
//       month: months[d.getMonth()],
//       isToday: i === 0,
//       fullDate: d,
//     };
//   });
// }

// function slotToDate(slot, baseDate) {
//   const [time, modifier] = slot.split(" ");
//   let [hours, minutes] = time.split(":").map(Number);
//   if (modifier === "PM" && hours !== 12) hours += 12;
//   if (modifier === "AM" && hours === 12) hours = 0;
//   const d = new Date(baseDate);
//   d.setHours(hours, minutes, 0, 0);
//   return d;
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 5 — Choose Date & Slot
// // ─────────────────────────────────────────────────────────
// function Screen5({ onNext, onBack, booking, setBooking }) {
//   const dates = useMemo(() => buildDates(), []);
//   const [selDateIdx, setSelDateIdx] = useState(0);
//   const [selSlot, setSelSlot] = useState(booking.slot || "");

//   const disabledSlots = useMemo(() => {
//     const disabled = [...MANUALLY_DISABLED_SLOTS];
//     if (dates[selDateIdx]?.isToday) {
//       const now = new Date();
//       ALL_SLOTS.forEach((s) => {
//         const t = slotToDate(s, dates[selDateIdx].fullDate);
//         if (t <= now && !disabled.includes(s)) disabled.push(s);
//       });
//     }
//     return disabled;
//   }, [selDateIdx, dates]);

//   const availableSlots = ALL_SLOTS.filter((s) => !disabledSlots.includes(s));
//   const nextAvailable = availableSlots[0];

//   function handleNext() {
//     const d = dates[selDateIdx];
//     setBooking((b) => ({
//       ...b,
//       slot: selSlot,
//       date: `${d.isToday ? "Today" : d.day}, ${d.date} ${d.month}`,
//     }));
//     onNext();
//   }

//   return (
//     <>
//       <Header step={5} total={7} />
//       <div className={styles.body}>
//         <div className={styles.twoColLeft230}>
//           {/* LEFT */}
//           <div>
//             <h2 className={styles.screenTitle}>Choose Date &amp; Slot</h2>
//             <p className={styles.screenSub}>Select a date and time that works for you.</p>

//             <div className={styles.dateStrip}>
//               {dates.map((d, i) => {
//                 const isSelDate = selDateIdx === i;
//                 let chipClass = styles.dateChip;
//                 if (d.isToday) chipClass += " " + styles.dateChipToday;
//                 else if (isSelDate) chipClass += " " + styles.dateChipSelected;

//                 return (
//                   <div
//                     key={i}
//                     className={chipClass}
//                     onClick={() => {
//                       setSelDateIdx(i);
//                       setSelSlot("");
//                     }}
//                   >
//                     <span className={styles.dcDay}>{d.isToday ? "Today" : d.day}</span>
//                     <span className={styles.dcDate}>{d.date}</span>
//                     <span className={styles.dcMonth}>{d.month}</span>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div>
//             <div className={styles.slotsHead}>
//               <span>
//                 {dates[selDateIdx].isToday ? "Today" : dates[selDateIdx].day},{" "}
//                 {dates[selDateIdx].date} {dates[selDateIdx].month}
//               </span>
//             </div>

//             {dates[selDateIdx].isToday && nextAvailable && (
//               <div className={styles.nextAvail}>
//                 <span className={styles.nextAvailDot} />
//                 Next available today: {nextAvailable}
//               </div>
//             )}

//             {ALL_SLOTS.length === 0 ? (
//               <div className={styles.noSlots}>No slots available for this date.</div>
//             ) : (
//               <div className={styles.slotsGrid}>
//                 {ALL_SLOTS.map((s) => {
//                   const isDisabled = disabledSlots.includes(s);
//                   const isSel = selSlot === s;
//                   let cls = styles.slotChip;
//                   if (isSel) cls += " " + styles.slotChipSelected;
//                   else if (isDisabled) cls += " " + styles.slotChipDisabled;

//                   return (
//                     <button
//                       key={s}
//                       className={cls}
//                       onClick={() => !isDisabled && setSelSlot(s)}
//                       disabled={isDisabled}
//                     >
//                       {s}
//                     </button>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         </div>

//         <NavRow
//           onBack={onBack}
//           onNext={handleNext}
//           disabled={!selSlot}
//           nextLabel="Continue"
//         />
//       </div>
//     </>
//   );
// }


// // ─────────────────────────────────────────────────────────
// //  SCREEN 6 — Confirm Details
// // ─────────────────────────────────────────────────────────
// function Screen6({ onNext, onBack, booking, goToStep }) {
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const doctor = cfg.doctors.find((d) => d.id === booking.doctorId) || cfg.doctors[0];
//   const mode = CONSULTATION_MODES.find((m) => m.id === booking.mode) || CONSULTATION_MODES[0];

//   const confirmRows = [
//     {
//       key: "Service",
//       val: cfg.recommendation.title,
//       icon: (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//           <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
//         </svg>
//       ),
//     },
//     {
//       key: "Date & Time",
//       val: `${booking.date} · ${booking.slot}`,
//       icon: (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//           <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
//         </svg>
//       ),
//     },
//     {
//       key: "Mode",
//       val: mode.title,
//       icon: (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//           <rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" />
//         </svg>
//       ),
//     },
//     {
//       key: "Location",
//       val: cfg.location,
//       icon: (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//           <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
//           <circle cx="12" cy="9" r="2.5" />
//         </svg>
//       ),
//     },
//     {
//       key: "Consultation Fee",
//       val: `₹${cfg.fee}`,
//       icon: (
//         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
//           <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
//         </svg>
//       ),
//       isFee: true,
//     },
//   ];

//   const summaryCtxIcons = {
//     "LIFE STAGE": (
//       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
//       </svg>
//     ),
//     "MAIN CONCERN": (
//       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
//       </svg>
//     ),
//     "VISIT TYPE": (
//       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
//       </svg>
//     ),
//     default: (
//       <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//         <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
//       </svg>
//     ),
//   };

//   const summaryRows = [
//     { key: "DOCTOR", val: doctor.name },
//     ...Object.entries(cfg.recommendation.context).map(([k, v]) => ({
//       key: k.toUpperCase(),
//       val: v,
//     })),
//   ];

//   return (
//     <>
//       <Header step={6} total={7} />
//       <div className={styles.body}>


//         {/* ── LEFT ── */}
//         <div className={styles.confirmLeft}>
//           {/* Title */}
//           <div className={styles.confirmTitleRow}>
//             <div className={styles.confirmCheckBadge}>
//               <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
//               </svg>
//             </div>
//             <h2 className={styles.screenTitle}>Confirm Details</h2>
//           </div>
//           <p className={styles.screenSub}>
//             Please review your appointment details before proceeding to payment.
//           </p>

//         </div>
//         <div className={styles.confirmTwoCol}>
//           <div>
//             {/* Doctor card */}
//             <div className={styles.confirmDocCard}>
//               <div className={styles.confirmDocAvatarWrap}>
//                 <span className={styles.confirmDocEmoji}>{doctor.emoji}</span>
//               </div>
//               <div>
//                 <div className={styles.confirmDocName}>{doctor.name}</div>
//                 <div className={styles.confirmDocTitle}>{doctor.title}</div>
//               </div>
//             </div>

//             {/* Confirm rows */}
//             <div className={styles.confirmRowsBox}>
//               {confirmRows.map((r, i) => (
//                 <div
//                   key={r.key}
//                   className={`${styles.confirmDetailRow} ${i < confirmRows.length - 1 ? styles.confirmDetailRowBorder : ""}`}
//                 >
//                   <div className={styles.confirmDetailLeft}>
//                     <span className={r.isFee ? styles.confirmDetailIconFee : styles.confirmDetailIcon}>
//                       {r.icon}
//                     </span>
//                     <span className={styles.confirmDetailKey}>{r.key}</span>
//                   </div>
//                   <span className={r.isFee ? styles.confirmDetailValFee : styles.confirmDetailVal}>
//                     {r.val}
//                   </span>
//                 </div>
//               ))}
//             </div>

//             {/* Edit Details */}
//             <div className={styles.editBtnWrap}>
//               <button
//                 className={styles.editDetailsBtn}
//                 onClick={() => goToStep(0)}
//               >
//                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//                   <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
//                   <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
//                 </svg>
//                 Edit Details
//               </button>
//             </div>
//           </div>

//           {/* ── RIGHT — Appointment Summary ── */}
//           <div className={styles.confirmSummaryPanel}>
//             <div className={styles.confirmSummaryHeader}>
//               <span className={styles.confirmSummaryTitle}>Appointment Summary</span>
//               <div className={styles.confirmSummaryIllo}>📋</div>
//             </div>

//             {summaryRows.map((r, i) => (
//               <div
//                 key={r.key}
//                 className={`${styles.confirmSummaryRow} ${i < summaryRows.length - 1 ? styles.confirmSummaryRowBorder : ""}`}
//               >
//                 <div className={styles.confirmSummaryRowLeft}>
//                   <span className={styles.confirmSummaryIcon}>
//                     {summaryCtxIcons[r.key] || summaryCtxIcons.default}
//                   </span>
//                   <span className={styles.confirmSummaryKey}>{r.key}</span>
//                 </div>
//                 <span className={styles.confirmSummaryVal}>{r.val}</span>
//               </div>
//             ))}

//             {/* Fee row */}
//             <div className={styles.confirmSummaryFeeRow}>
//               <div className={styles.confirmSummaryRowLeft}>
//                 <span className={styles.confirmSummaryIcon}>
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
//                   </svg>
//                 </span>
//                 <span className={styles.confirmSummaryKey}>FEE</span>
//               </div>
//               <span className={styles.confirmSummaryFeeVal}>₹{cfg.fee}</span>
//             </div>
//           </div>
//         </div>

//         {/* Nav */}
//         <div className={styles.confirmNavRow}>
//           <button className={styles.btnOutline} onClick={onBack}>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M19 12H5M12 19l-7-7 7-7" />
//             </svg>
//             Back
//           </button>
//           <button className={styles.btnPrimaryLarge} onClick={onNext}>
//             Continue to Payment
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
//               <circle cx="12" cy="12" r="10" />
//               <path d="M12 8l4 4-4 4M8 12h8" />
//             </svg>
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }


// // ─────────────────────────────────────────────────────────
// //  SCREEN 7 — Payment
// // ─────────────────────────────────────────────────────────
// function Screen7({ onNext, onBack, booking }) {
//   const [sel, setSel] = useState("upi");
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const doctor =
//     (TYPE_CONFIGS[booking.type]?.doctors || []).find(
//       (d) => d.id === booking.doctorId
//     ) || TYPE_CONFIGS[booking.type]?.doctors?.[0];

//   const METHODS = [
//     {
//       id: "upi",
//       label: "UPI",
//       sub: "Google Pay, PhonePe, Paytm, BHIM",
//       icon: (
//         <span style={{ fontSize: 16, fontWeight: 900, letterSpacing: -1, color: "#097939", lineHeight: 1 }}>
//           U<span style={{ color: "#e9784e" }}>P</span>I
//         </span>
//       ),
//     },
//     {
//       id: "card",
//       label: "Debit / Credit Card",
//       sub: "Visa, Mastercard, RuPay",
//       icon: (
//         <svg width="32" height="22" viewBox="0 0 36 24" fill="none">
//           <rect width="36" height="24" rx="4" fill="#f0f4ff" />
//           <rect x="3" y="9" width="30" height="4" fill="#4f46e5" rx="1" />
//           <rect x="3" y="16" width="8" height="3" rx="1" fill="#818cf8" />
//           <rect x="14" y="16" width="5" height="3" rx="1" fill="#818cf8" />
//         </svg>
//       ),
//     },
//     {
//       id: "netbanking",
//       label: "Net Banking",
//       sub: "All major banks supported",
//       icon: (
//         <svg width="28" height="26" viewBox="0 0 32 28" fill="none">
//           <rect x="2" y="10" width="28" height="16" rx="2" fill="#eff6ff" stroke="#bfdbfe" strokeWidth="1.5" />
//           <rect x="6" y="14" width="4" height="8" rx="1" fill="#3b82f6" />
//           <rect x="14" y="14" width="4" height="8" rx="1" fill="#3b82f6" />
//           <rect x="22" y="14" width="4" height="8" rx="1" fill="#3b82f6" />
//           <path d="M16 2L2 10h28L16 2z" fill="#2563eb" />
//         </svg>
//       ),
//     },
//     {
//       id: "wallet",
//       label: "Wallets",
//       sub: "Paytm, Mobikwik, Amazon Pay",
//       icon: (
//         <svg width="28" height="26" viewBox="0 0 32 28" fill="none">
//           <rect x="2" y="6" width="28" height="18" rx="3" fill="#fef3c7" stroke="#fde68a" strokeWidth="1.5" />
//           <rect x="20" y="10" width="8" height="8" rx="3" fill="#f59e0b" />
//           <circle cx="23" cy="14" r="2" fill="#fef3c7" />
//         </svg>
//       ),
//     },
//   ];

//   return (
//     <>
//       <Header step={7} total={7} />

//       <div className={styles.body}>
//         <div className={styles.twoCol} style={{ gridTemplateColumns: "1fr 280px" }}>

//           {/* ── LEFT ── */}
//           <div>
//             {/* Page header */}
//             <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
//               <div className={styles.optionIcon} style={{ background: "var(--plum-s)", flexShrink: 0 }}>
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--plum-m)" strokeWidth="2">
//                   <rect x="3" y="11" width="18" height="11" rx="2" />
//                   <path d="M7 11V7a5 5 0 0110 0v4" />
//                 </svg>
//               </div>
//               <div>
//                 <h2 className={styles.screenTitle} style={{ marginBottom: 2 }}>Complete Your Payment</h2>
//                 <p className={styles.screenSub} style={{ marginBottom: 0 }}>
//                   Secure your appointment by completing the payment.
//                 </p>
//               </div>
//             </div>

//             {/* Amount card */}
//             <div style={{
//               background: "var(--plum-d)",
//               borderRadius: "var(--radius)",
//               padding: "18px 22px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 22,
//             }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
//                 <div style={{
//                   width: 42, height: 42,
//                   background: "rgba(255,255,255,0.15)",
//                   borderRadius: "var(--radius-sm)",
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                 }}>
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
//                     <rect x="2" y="5" width="20" height="14" rx="2" />
//                     <path d="M2 10h20" />
//                   </svg>
//                 </div>
//                 <div>
//                   <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Amount Payable</div>
//                   <div style={{ fontSize: 11, color: "rgba(255,255,255,0.65)", marginTop: 2 }}>Consultation Fee</div>
//                 </div>
//               </div>
//               <div style={{ fontSize: 30, fontWeight: 800, color: "#fff", letterSpacing: -1 }}>₹{cfg.fee}</div>
//             </div>

//             {/* Payment methods label */}
//             <div className={styles.payMethodsLabel}>Choose a payment method</div>

//             {/* Payment methods */}
//             {METHODS.map((m) => (
//               <div
//                 key={m.id}
//                 className={`${styles.payMethod} ${sel === m.id ? styles.selected : ""}`}
//                 onClick={() => setSel(m.id)}
//               >
//                 <div className={styles.payMethodIcon}>{m.icon}</div>
//                 <div className={styles.payMethodText} style={{ flex: 1 }}>
//                   <strong>
//                     {m.label}
//                     <span style={{
//                       display: "inline-block",
//                       background: "var(--green-l)",
//                       color: "var(--green)",
//                       border: "1px solid var(--green-b)",
//                       fontSize: 10,
//                       fontWeight: 700,
//                       padding: "2px 8px",
//                       borderRadius: 99,
//                       marginLeft: 8,
//                       verticalAlign: "middle",
//                     }}>
//                       Instant &amp; Secure
//                     </span>
//                   </strong>
//                   <span>{m.sub}</span>
//                 </div>
//                 <Radio checked={sel === m.id} />
//               </div>
//             ))}

//             {/* Trust row */}
//             {/* <div style={{
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr 1fr",
//               border: "1px solid var(--border)",
//               borderRadius: "var(--radius)",
//               overflow: "hidden",
//               marginTop: 18,
//             }}>
//               {[
//                 {
//                   bg: "#eff6ff", stroke: "#2563eb",
//                   path: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
//                   title: "100% Secure", sub: "Your data is protected",
//                 },
//                 {
//                   bg: "var(--plum-l)", stroke: "var(--plum-m)",
//                   path: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />,
//                   title: "Instant Confirmation", sub: "Confirmed immediately",
//                 },
//                 {
//                   bg: "#f0fdfa", stroke: "#0d9488",
//                   path: <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />,
//                   title: "Need Help?", sub: "Contact our support",
//                 },
//               ].map((t, i) => (
//                 <div key={i} style={{
//                   padding: "12px 14px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                   borderRight: i < 2 ? "1px solid var(--border)" : "none",
//                   background: "var(--card-bg)",
//                 }}>
//                   <div style={{
//                     width: 30, height: 30, borderRadius: "var(--radius-sm)",
//                     background: t.bg,
//                     display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
//                   }}>
//                     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={t.stroke} strokeWidth="2">
//                       {t.path}
//                     </svg>
//                   </div>
//                   <div>
//                     <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text)" }}>{t.title}</div>
//                     <div style={{ fontSize: 10, color: "var(--muted)", marginTop: 1 }}>{t.sub}</div>
//                   </div>
//                 </div>
//               ))}
//             </div> */}
//           </div>

//           {/* ── RIGHT — Appointment Summary ── */}
//           <div className={styles.payIllo} style={{ padding: 20 }}>
//             <div className={styles.sidePanelTitle}>Appointment Summary</div>

//             {/* Date + Time side by side */}
//             <div style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//               padding: "9px 0",
//               borderBottom: "1px solid var(--border)",
//             }}>
//               {/* Date */}
//               <div style={{
//                 width: 28, height: 28,
//                 borderRadius: "var(--radius-sm)",
//                 background: "var(--plum-s)",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 flexShrink: 0,
//               }}>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--plum-m)" strokeWidth="2">
//                   <rect x="3" y="4" width="18" height="18" rx="2" />
//                   <path d="M16 2v4M8 2v4M3 10h18" />
//                 </svg>
//               </div>
//               <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
//                 {booking.date || "—"}
//               </span>

//               {/* Divider */}
//               <div style={{ width: 1, height: 18, background: "var(--border)", flexShrink: 0 }} />

//               {/* Time */}
//               <div style={{
//                 width: 28, height: 28,
//                 borderRadius: "var(--radius-sm)",
//                 background: "var(--plum-s)",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 flexShrink: 0,
//               }}>
//                 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--plum-m)" strokeWidth="2">
//                   <circle cx="12" cy="12" r="10" />
//                   <path d="M12 6v6l4 2" />
//                 </svg>
//               </div>
//               <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>
//                 {booking.slot || "—"}
//               </span>
//             </div>

//             {/* Doctor */}
//             <div style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               padding: "10px 0",
//               borderBottom: "1px solid var(--border)",
//               marginBottom: 4,
//             }}>
//               <div className={styles.confirmDocAvatar}>{doctor?.emoji || "👩‍⚕️"}</div>
//               <div>
//                 <div className={styles.confirmDocName}>{doctor?.name || "—"}</div>
//                 <div className={styles.confirmDocTitle}>{doctor?.title || "—"}</div>
//                 <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 1 }}>{cfg.location || "—"}</div>
//               </div>
//             </div>

//             {/* Payment details */}
//             <hr className={styles.summaryDivider} />
//             <div className={styles.sidePanelTitle} style={{ marginBottom: 10 }}>Payment Details</div>

//             <div className={styles.summaryRow}>
//               <span className={styles.summaryKey}>Consultation Fee</span>
//               <span className={styles.summaryVal}>₹{cfg.fee}</span>
//             </div>
//             <div className={styles.summaryRow} style={{
//               borderTop: "1px solid var(--plum-b)",
//               paddingTop: 8,
//               marginTop: 4,
//             }}>
//               <span style={{ fontSize: 13, fontWeight: 800, color: "var(--plum-d)" }}>Total Amount</span>
//               <span style={{ fontSize: 15, fontWeight: 800, color: "var(--plum-d)" }}>₹{cfg.fee}</span>
//             </div>

//             {/* Security items */}
//             <hr className={styles.summaryDivider} />
//             {[
//               {
//                 bg: "var(--green-l)", stroke: "var(--green)",
//                 path: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
//                 title: "Secure Payment",
//                 sub: "Your transaction is encrypted and 100% secure",
//               },
//               {
//                 bg: "#f0fdfa", stroke: "#0d9488",
//                 path: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></>,
//                 title: "PCI DSS Compliant",
//                 sub: "Industry-standard security protocols",
//               },
//             ].map((s, i) => (
//               <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 10 }}>
//                 <div style={{
//                   width: 32, height: 32,
//                   borderRadius: "var(--radius-sm)",
//                   background: s.bg, flexShrink: 0,
//                   display: "flex", alignItems: "center", justifyContent: "center",
//                 }}>
//                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={s.stroke} strokeWidth="2">{s.path}</svg>
//                 </div>
//                 <div>
//                   <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text)" }}>{s.title}</div>
//                   <div style={{ fontSize: 10, color: "var(--muted)", marginTop: 1 }}>{s.sub}</div>
//                 </div>
//               </div>
//             ))}

//             {/* Brand logos */}
//             <div className={styles.payBadges} style={{ justifyContent: "space-between", marginTop: 14 }}>
//               <span style={{ background: "#1e40af", color: "#fff", fontSize: 10, fontWeight: 800, padding: "4px 8px", borderRadius: 6 }}>
//                 PCI DSS
//               </span>
//               <span style={{ background: "#ff6b00", color: "#fff", fontSize: 10, fontWeight: 800, padding: "4px 8px", borderRadius: 6 }}>
//                 Ru<span style={{ color: "#ffd700" }}>Pay</span>
//               </span>
//               <span style={{ color: "#072654", fontWeight: 800, fontSize: 11 }}>/Razorpay</span>
//             </div>
//           </div>
//         </div>

//         {/* ── FOOTER NAV ── */}
//         <div className={`${styles.navRow} ${styles.navRowSpaced}`}>
//           <button className={styles.btnOutline} onClick={onBack}>
//             <ArrowLeft /> Back
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--muted)" }}>
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2">
//               <rect x="3" y="11" width="18" height="11" rx="2" />
//               <path d="M7 11V7a5 5 0 0110 0v4" />
//             </svg>
//             You will be redirected to the payment gateway to complete your transaction securely.
//           </div>
//           <button className={`btn-primary ${styles.btnPrimary}`} onClick={onNext} style={{ padding: "12px 28px", fontSize: 14 }}>
//             <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
//               <rect x="3" y="11" width="18" height="11" rx="2" />
//               <path d="M7 11V7a5 5 0 0110 0v4" />
//             </svg>
//             Pay ₹{cfg.fee} Securely <ArrowRight />
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  SCREEN 8 — Appointment Confirmed
// // ─────────────────────────────────────────────────────────
// function Screen8({ booking }) {
//   const cfg = TYPE_CONFIGS[booking.type] || TYPE_CONFIGS.doctor;
//   const doctor = cfg.doctors.find((d) => d.id === booking.doctorId) || cfg.doctors[0];
//   const mode = CONSULTATION_MODES.find((m) => m.id === booking.mode) || CONSULTATION_MODES[0];

//   const aptId = `APT-${Math.floor(10000000 + Math.random() * 90000000)}`;

//   const aptRows = [
//     { key: "Doctor", val: doctor.name },
//     { key: "Date & Time", val: `${booking.date} · ${booking.slot}` },
//     { key: "Mode", val: mode.title },
//     { key: "Location", val: cfg.location },
//   ];

//   return (
//     <>
//       <Header step={7} total={7} />
//       <div className={styles.body}>
//         <div className={styles.confirmCenter}>
//           <div className={styles.confirmCheck}>✓</div>
//           <h2 className={styles.confirmHeadline}>Appointment Confirmed!</h2>
//           <p className={styles.confirmDesc}>
//             Your appointment has been booked successfully.
//           </p>

//           <div className={styles.confirmAptCard}>
//             <div className={styles.confirmAptId}>📋 {aptId}</div>
//             {aptRows.map((r) => (
//               <div key={r.key} className={styles.confirmAptRow}>
//                 <span className={styles.carKey}>{r.key}</span>
//                 <span className={styles.carVal}>{r.val}</span>
//               </div>
//             ))}
//           </div>

//           <div className={styles.confirmSms}>
//             ✅ A confirmation email &amp; SMS has been sent to you.
//           </div>

//           <div className={styles.confirmActions}>
//             <a href="/" className={`btn-primary ${styles.btnPrimary}`}>
//               Go to Dashboard
//             </a>
//             <button className={styles.btnSecondary}>📅 Add to Calendar</button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// // ─────────────────────────────────────────────────────────
// //  ORCHESTRATOR
// // ─────────────────────────────────────────────────────────
// const SCREEN_COUNT = 7; // steps shown in progress bar (step 8 is confirmation, same as 7)

// export default function BookingFlow() {
//   const [step, setStep] = useState(0);
//   const [booking, setBooking] = useState({
//     type: APPOINTMENT_TYPES[0].id,
//     doctorId: null,
//     mode: null,
//     date: null,
//     slot: null,
//   });

//   const next = () => setStep((s) => s + 1);
//   const back = () => setStep((s) => Math.max(0, s - 1));
//   const goToStep = (s) => setStep(s);

//   const sharedProps = { booking, setBooking, onNext: next, onBack: back, goToStep };

//   const screens = [
//     <Screen1 key="s1" {...sharedProps} />,
//     <Screen2 key="s2" {...sharedProps} />,
//     <Screen3 key="s3" {...sharedProps} />,
//     <Screen4 key="s4" {...sharedProps} />,
//     <Screen5 key="s5" {...sharedProps} />,
//     <Screen6 key="s6" {...sharedProps} />,
//     <Screen7 key="s7" {...sharedProps} />,
//     <Screen8 key="s8" {...sharedProps} />,
//   ];

//   return (
//     <>
//       <DigitalHealthFAB />
//       <div className={styles.page}>
//         <div className={styles.card}>
//           {screens[step]}
//         </div>
//       </div>
//     </>
//   );
// }
//  ═══════════════════════════════════════════════════════════
//  FemCare — BookingFlow.jsx  (fully dynamic version)
//  Screens: Type → Service → Provider → Mode → Date/Slot →
//           Confirm → Patient Details → [OTP] → Payment → Confirmed
//
//  Everything from Screen 1 onward is driven by live API data:
//    GET  {API_ROOT}/clinic-onboarding/clinics/{CLINIC_ID}/services
//    GET  {API_ROOT}/clinic-onboarding/clinics/{CLINIC_ID}/providers/filter?specialityName=...
//    GET  {API_ROOT}/clinic-onboarding/providers/{providerId}/slots
//    POST {API_ROOT}/book-an-appointment/appointment/book
//
//  Patient details / OTP / payment steps reuse the same
//  "skip OTP if already verified" pattern used in
//  components/OurDoctors/AppointmentBar's BookAppointment.jsx.
//
//  ⚠️ Adjust the relative import paths below (auth hook, auth
//  api, storage utils, Notification) to match where this file
//  actually lives in your project tree.
// ═══════════════════════════════════════════════════════════

import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "../styles/Bookingflow.module.css";
import DigitalHealthFAB from "../components/Digitalhealth";
import { useAuth } from "../hooks/useAuth";
import { sendQuickOtp, quickRegister, verifyOtp } from "../api/auth.api";
import { isMobileVerified, storePatientSession } from "../utils/storage/authStorage";
import { Notification } from "../utils";

// ─────────────────────────────────────────────────────────
//  API config
// ─────────────────────────────────────────────────────────
const API_ROOT = "https://api.avexa.net";

// NOTE: your sample endpoints used two different clinic ids —
// one for services/providers, another for the booking POST.
// Keeping them as separate constants so you can point either
// (or both) at the right clinic for your environment.
const CLINIC_ID = "6a3ba96dc8e05c65af7f0ef0";
const BOOKING_CLINIC_ID = "6a3ba96dc8e05c65af7f0ef0";
const CLINIC_LOCATION = "FemCare Clinic, Bhubaneswar, Odisha 751006";

const OTP_LENGTH = 6;

async function fetchClinicServices() {
  const res = await fetch(`${API_ROOT}/clinic-onboarding/clinics/${CLINIC_ID}/services`);
  if (!res.ok) throw new Error("Failed to load services");
  const data = await res.json();
  return Array.isArray(data) ? data.filter((s) => s.status === "ACTIVE") : [];
}

async function fetchAllProviders() {
  const res = await fetch(`${API_ROOT}/clinic-onboarding/clinics/${CLINIC_ID}/providers`);
  if (!res.ok) throw new Error("Failed to load providers");
  const data = await res.json();
  console.log("data ", data)
  return data?.providers ?? [];
}

// Match a service's speciality against a provider's speciality. Prefer
// matching on specialityId (exact/stable), fall back to a case-insensitive
// name comparison since some service records only carry specialityName.
function providerMatchesSpeciality(provider, service) {
  if (!service) return true;
  const svcId = service.specialityId;
  const svcName = (service.specialityName || "").trim().toLowerCase();
  const provId = provider.specialityId;
  const provName = (provider.speciality?.specialityName || "").trim().toLowerCase();

  if (svcId && provId) return svcId === provId;
  if (svcName && provName) return svcName === provName;
  return false;
}

async function fetchProviderSlots(providerId) {
  const res = await fetch(`${API_ROOT}/clinic-onboarding/providers/${providerId}/slots`);
  if (!res.ok) throw new Error("Failed to load slots");
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

// ─────────────────────────────────────────────────────────
//  Small data helpers
// ─────────────────────────────────────────────────────────
function groupServicesBySpeciality(services) {
  const map = new Map();
  services.forEach((svc) => {
    const key = svc.specialityName || svc.categoryName || "General";
    if (!map.has(key)) {
      map.set(key, { id: key, title: key, services: [] });
    }
    map.get(key).services.push(svc);
  });
  return Array.from(map.values());
}

const TYPE_ICON_MAP = {
  gynaecology: "🩺",
  gynecology: "🩺",
  obstetric: "🤰",
  "general medicine": "👩‍⚕️",
};
function getTypeIcon(title = "") {
  const lower = title.toLowerCase();
  const match = Object.keys(TYPE_ICON_MAP).find((k) => lower.includes(k));
  return match ? TYPE_ICON_MAP[match] : "🏥";
}

function modeIcon(name = "") {
  const n = name.toLowerCase();
  if (n.includes("video")) return "🎥";
  if (n.includes("phone")) return "📞";
  return "🏥";
}
function modeSub(name = "") {
  const n = name.toLowerCase();
  if (n.includes("video")) return "Consult from home via video";
  if (n.includes("phone")) return "Audio call with your doctor";
  return "Visit the clinic in person";
}
const CONSULTATION_MODES_FALLBACK = [
  { id: "inperson", name: "In Person" },
  { id: "video", name: "Video Consult" },
];

function buildDates() {
  const today = new Date();
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    return {
      day: days[d.getDay()],
      date: d.getDate(),
      month: months[d.getMonth()],
      isToday: i === 0,
      fullDate: d,
    };
  });
}

function localDateStr(fullDate) {
  const y = fullDate.getFullYear();
  const m = String(fullDate.getMonth() + 1).padStart(2, "0");
  const d = String(fullDate.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function formatSlotTime(time24) {
  const [h, m] = time24.split(":").map(Number);
  const ampm = h < 12 ? "AM" : "PM";
  const hour12 = h === 0 ? 12 : h > 12 ? h - 12 : h;
  return `${hour12}:${m.toString().padStart(2, "0")} ${ampm}`;
}

// ─────────────────────────────────────────────────────────
//  SVG Icons
// ─────────────────────────────────────────────────────────
const ArrowRight = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
  </svg>
);
const ArrowLeft = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
  </svg>
);

const Logo = () => (
  <div className="flex items-center gap-2">
    <img src="/Home/FemCareLogo.svg" alt="femcare" className="h-8 md:h-8 w-auto" />
  </div>
);

// Total number of *countable* steps shown in the progress bar.
// (The OTP screen is inserted conditionally and doesn't get its
// own slot in the count — it reuses the "Patient Details" slot.)
const TOTAL_STEPS = 8;

function Header({ step, total = TOTAL_STEPS }) {
  const pct = Math.round((step / total) * 100);
  return (
    <>
      <div className={styles.header}>
        <Logo />
        <a href="/" className={styles.saveExit}>
          Save &amp; Exit
        </a>
      </div>
      <div className={styles.progressRow}>
        <span className={styles.stepLabel}>
          Step {step} of {total}
        </span>
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: `${pct}%` }} />
        </div>
      </div>
    </>
  );
}

function Radio({ checked }) {
  return (
    <div className={styles.radio} style={checked ? { background: "#6b1a9a", borderColor: "#6b1a9a" } : {}}>
      {checked && <div className={styles.radioDot} />}
    </div>
  );
}

function NavRow({ onBack, onNext, nextLabel = "Continue", disabled = false }) {
  return (
    <div className={`${styles.navRow} ${onBack ? styles.navRowSpaced : ""}`}>
      {onBack && (
        <button className={styles.btnOutline} onClick={onBack}>
          <ArrowLeft /> Back
        </button>
      )}
      <button className={`btn-primary ${styles.btnPrimary}`} onClick={onNext} disabled={disabled}>
        {nextLabel} <ArrowRight />
      </button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────
//  Skeletons
// ─────────────────────────────────────────────────────────
const TypeSkeleton = () => (
  <div className={styles.twoCol}>
    <div>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="ava-skeleton" style={{ height: 76, borderRadius: 14, marginBottom: 12 }} />
      ))}
    </div>
    <div className="ava-skeleton" style={{ height: 220, borderRadius: 16 }} />
  </div>
);

const ProviderSkeleton = () => (
  <>
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="ava-skeleton" style={{ height: 96, borderRadius: 14, marginBottom: 12 }} />
    ))}
  </>
);

const SlotSkeletonGrid = () => (
  <div className={styles.slotsGrid}>
    {Array.from({ length: 12 }).map((_, i) => (
      <div key={i} className="ava-skeleton" style={{ height: 34, borderRadius: 8 }} />
    ))}
  </div>
);

// ─────────────────────────────────────────────────────────
//  SCREEN 1 — Appointment Type (grouped live from services)
// ─────────────────────────────────────────────────────────
function Screen1TypeSelect({ onNext, booking, setBooking }) {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sel, setSel] = useState(booking.typeId || null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchClinicServices();
        if (!cancelled) setServices(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "Could not load appointment types.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const types = useMemo(() => groupServicesBySpeciality(services), [services]);

  useEffect(() => {
    if (!sel && types.length > 0) setSel(types[0].id);
  }, [types, sel]);

  function handleNext() {
    const type = types.find((t) => t.id === sel);
    setBooking((b) => ({ ...b, typeId: sel, typeServices: type?.services || [] }));
    onNext();
  }

  return (
    <>
      <Header step={1} />
      <div className={styles.body}>
        <div>
          <h1 className={styles.screenTitle}>What type of appointment do you need?</h1>
          <p className={styles.screenSub}>Select the reason for your visit.</p>
        </div>

        {loading ? (
          <TypeSkeleton />
        ) : error ? (
          <div className={styles.noSlots}>{error}</div>
        ) : (
          <div className={styles.twoCol}>
            <div>
              {types.map((t) => (
                <div
                  key={t.id}
                  className={`${styles.optionCard} ${sel === t.id ? styles.selected : ""}`}
                  onClick={() => setSel(t.id)}
                >
                  <div className={styles.optionIcon}>{getTypeIcon(t.title)}</div>
                  <div className={styles.optionText}>
                    <strong>{t.title}</strong>
                    <span>
                      {t.services.length} service{t.services.length !== 1 ? "s" : ""} available
                    </span>
                  </div>
                  <Radio checked={sel === t.id} />
                </div>
              ))}
              {types.length === 0 && <div className={styles.noSlots}>No appointment types available right now.</div>}
            </div>
            <div className={styles.illoWrap}>
              <img src="/images/appointment.png" className="h-84" alt="" />
            </div>
          </div>
        )}

        <NavRow onNext={handleNext} nextLabel="Continue" disabled={!sel || loading} />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 2 — Service selection within chosen type
// ─────────────────────────────────────────────────────────
function Screen2ServiceSelect({ onNext, onBack, booking, setBooking }) {
  const services = booking.typeServices || [];
  const [sel, setSel] = useState(booking.service?.id || services[0]?.id || null);

  const selectedService = services.find((s) => s.id === sel);

  function handleNext() {
    setBooking((b) => ({ ...b, service: selectedService }));
    onNext();
  }

  return (
    <>
      <Header step={2} />
      <div className={styles.body}>
        <div>
          <h2 className={styles.screenTitle}>Choose a service</h2>
          <p className={styles.screenSub}>Select the specific service you need.</p>
        </div>

        <div className={styles.twoCol}>
          <div>
            {services.map((svc) => (
              <div
                key={svc.id}
                className={`${styles.optionCard} ${sel === svc.id ? styles.selected : ""}`}
                onClick={() => setSel(svc.id)}
              >
                <div className={styles.optionIcon}>{getTypeIcon(svc.specialityName)}</div>
                <div className={styles.optionText}>
                  <strong>{svc.serviceName}</strong>
                  <span>
                    {svc.duration} min · ₹{svc.price}
                  </span>
                </div>
                <Radio checked={sel === svc.id} />
              </div>
            ))}
            {services.length === 0 && <div className={styles.noSlots}>No services available for this type.</div>}
          </div>

          <div className={styles.sidePanel}>
            <div className={styles.sidePanelTitle}>Service Details</div>
            {selectedService ? (
              <>
                <p className={styles.recReason}>{selectedService.description}</p>
                <div className={styles.ctxRow}>
                  <div className={styles.ctxKey}>Speciality</div>
                  <div className={styles.ctxVal}>{selectedService.specialityName}</div>
                </div>
                <div className={styles.ctxRow}>
                  <div className={styles.ctxKey}>Duration</div>
                  <div className={styles.ctxVal}>{selectedService.duration} mins</div>
                </div>
                <div className={styles.ctxRow}>
                  <div className={styles.ctxKey}>Fee</div>
                  <div className={styles.ctxVal}>₹{selectedService.price}</div>
                </div>
                <div className={styles.ctxNote}>You can modify this later if needed.</div>
              </>
            ) : (
              <div className={styles.ctxNote}>Select a service to see details.</div>
            )}
          </div>
        </div>

        <NavRow onBack={onBack} onNext={handleNext} disabled={!selectedService} />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 3 — Provider list, filtered by the service's speciality
// ─────────────────────────────────────────────────────────
function Screen3ProviderSelect({ onNext, onBack, booking, setBooking }) {
  const service = booking.service;
  const specialityName = service?.specialityName;
  const [allProviders, setAllProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sel, setSel] = useState(booking.doctorId || null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await fetchAllProviders();
        if (!cancelled) setAllProviders(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "Could not load providers.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const providers = useMemo(
    () => allProviders.filter((p) => providerMatchesSpeciality(p, service)),
    [allProviders, service]
  );

  function handleNext() {
    const doctor = providers.find((d) => d.providerId === sel);
    setBooking((b) => ({ ...b, doctorId: sel, doctor }));
    onNext();
  }

  return (
    <>
      <Header step={3} />
      <div className={styles.body}>
        <div style={{ marginBottom: 4 }}>
          <h2 className={styles.screenTitle}>Choose your doctor</h2>
          <p className={styles.screenSub}>Available specialists for {specialityName || "this service"}.</p>
        </div>

        {loading ? (
          <ProviderSkeleton />
        ) : error ? (
          <div className={styles.noSlots}>{error}</div>
        ) : providers.length === 0 ? (
          <div className={styles.noSlots}>No providers available for this speciality right now.</div>
        ) : (
          providers.map((d) => (
            <div
              key={d.providerId}
              className={`${styles.docCard} ${sel === d.providerId ? styles.selected : ""}`}
              onClick={() => setSel(d.providerId)}
            >
              <div className={styles.docAvatar}>👩‍⚕️</div>
              <div className={styles.docInfo}>
                <div className={styles.docName}>{d.fullName}</div>
                <div className={styles.docTitle}>{d.speciality?.specialityName}</div>
                <div className={styles.docMeta}>
                  <div className={styles.docExp}>✉️ {d.email}</div>
                </div>
                {d.verificationStatus && (
                  <div className={styles.docTags}>
                    <span className={styles.docTag}>{d.verificationStatus.replace(/_/g, " ")}</span>
                  </div>
                )}
              </div>
              <div
                className={styles.radio}
                style={sel === d.providerId ? { background: "#6b1a9a", borderColor: "#6b1a9a" } : {}}
              >
                {sel === d.providerId && <div className={styles.radioDot} />}
              </div>
            </div>
          ))
        )}

        <NavRow onBack={onBack} onNext={handleNext} disabled={!sel || loading} nextLabel="Continue" />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 4 — Consultation mode (from the selected service)
// ─────────────────────────────────────────────────────────
function Screen4ModeSelect({ onNext, onBack, booking, setBooking }) {
  const rawModes = (booking.service?.consultationModes || []).filter((m) => m && m.name);
  const modes = rawModes.length ? rawModes : CONSULTATION_MODES_FALLBACK;
  const [sel, setSel] = useState(booking.mode?.id || modes[0]?.id);

  function handleNext() {
    const mode = modes.find((m) => m.id === sel);
    setBooking((b) => ({ ...b, mode }));
    onNext();
  }

  return (
    <>
      <Header step={4} />
      <div className={styles.body}>
        <div>
          <h2 className={styles.screenTitle}>Select Consultation Mode</h2>
          <p className={styles.screenSub}>How would you like to consult? Choose your preferred mode.</p>
        </div>
        <div className={styles.twoCol}>
          <div>
            {modes.map((m) => (
              <div
                key={m.id}
                className={`${styles.optionCard} ${sel === m.id ? styles.selected : ""}`}
                onClick={() => setSel(m.id)}
              >
                <div className={styles.optionIcon}>{modeIcon(m.name)}</div>
                <div className={styles.optionText}>
                  <strong>{m.name}</strong>
                  <span>{modeSub(m.name)}</span>
                </div>
                <Radio checked={sel === m.id} />
              </div>
            ))}
          </div>
          <div className={styles.sidePanel}>
            <div className={styles.sidePanelTitle}>Your Selection</div>
            <div className={styles.ctxRow}>
              <div className={styles.ctxKey}>Service</div>
              <div className={styles.ctxVal}>{booking.service?.serviceName}</div>
            </div>
            <div className={styles.ctxRow}>
              <div className={styles.ctxKey}>Doctor</div>
              <div className={styles.ctxVal}>{booking.doctor?.fullName}</div>
            </div>
            <div className={styles.ctxNote}>You can modify this later if needed.</div>
          </div>
        </div>
        <NavRow onBack={onBack} onNext={handleNext} />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 5 — Date & Slot (live from the provider's slots API)
// ─────────────────────────────────────────────────────────
function Screen5DateSlot({ onNext, onBack, booking, setBooking }) {
  const dates = useMemo(() => buildDates(), []);
  const [allSlots, setAllSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selDateIdx, setSelDateIdx] = useState(0);
  const [selSlot, setSelSlot] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!booking.doctorId) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const data = await fetchProviderSlots(booking.doctorId);
        if (!cancelled) setAllSlots(data);
      } catch (err) {
        if (!cancelled) setError(err.message || "Could not load slots.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [booking.doctorId]);

  const slotsForDay = useMemo(() => {
    const day = dates[selDateIdx];
    if (!day) return [];
    const dateStr = localDateStr(day.fullDate);
    const now = new Date();
    return allSlots
      .filter((s) => s.slotDate === dateStr)
      .map((s) => {
        const [h, m] = s.startTime.split(":").map(Number);
        const slotDateTime = new Date(
          day.fullDate.getFullYear(),
          day.fullDate.getMonth(),
          day.fullDate.getDate(),
          h,
          m,
          0,
          0
        );
        const isPast = slotDateTime <= now;
        const isOccupied = s.status !== "AVAILABLE";
        return { ...s, label: formatSlotTime(s.startTime), disabled: isPast || isOccupied };
      })
      .sort((a, b) => a.startTime.localeCompare(b.startTime));
  }, [allSlots, dates, selDateIdx]);

  function handleNext() {
    const d = dates[selDateIdx];
    setBooking((b) => ({
      ...b,
      slot: selSlot.label,
      slotId: selSlot.slotId,
      slotDate: selSlot.slotDate,
      date: `${d.isToday ? "Today" : d.day}, ${d.date} ${d.month}`,
    }));
    onNext();
  }

  return (
    <>
      <Header step={5} />
      <div className={styles.body}>
        <div className={styles.twoColLeft230}>
          <div>
            <h2 className={styles.screenTitle}>Choose Date &amp; Slot</h2>
            <p className={styles.screenSub}>Select a date and time that works for you.</p>
            <div className={styles.dateStrip}>
              {dates.map((d, i) => {
                const isSelDate = selDateIdx === i;
                let chipClass = styles.dateChip;
                if (d.isToday) chipClass += " " + styles.dateChipToday;
                else if (isSelDate) chipClass += " " + styles.dateChipSelected;
                return (
                  <div
                    key={i}
                    className={chipClass}
                    onClick={() => {
                      setSelDateIdx(i);
                      setSelSlot(null);
                    }}
                  >
                    <span className={styles.dcDay}>{d.isToday ? "Today" : d.day}</span>
                    <span className={styles.dcDate}>{d.date}</span>
                    <span className={styles.dcMonth}>{d.month}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <div className={styles.slotsHead}>
              <span>
                {dates[selDateIdx].isToday ? "Today" : dates[selDateIdx].day}, {dates[selDateIdx].date}{" "}
                {dates[selDateIdx].month}
              </span>
            </div>

            {loading ? (
              <SlotSkeletonGrid />
            ) : error ? (
              <div className={styles.noSlots}>{error}</div>
            ) : slotsForDay.length === 0 ? (
              <div className={styles.noSlots}>No slots available for this date.</div>
            ) : (
              <div className={styles.slotsGrid}>
                {slotsForDay.map((s) => {
                  const isSel = selSlot?.slotId === s.slotId;
                  let cls = styles.slotChip;
                  if (isSel) cls += " " + styles.slotChipSelected;
                  else if (s.disabled) cls += " " + styles.slotChipDisabled;
                  return (
                    <button key={s.slotId} className={cls} onClick={() => !s.disabled && setSelSlot(s)} disabled={s.disabled}>
                      {s.label}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <NavRow onBack={onBack} onNext={handleNext} disabled={!selSlot} nextLabel="Continue" />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 6 — Confirm Details
// ─────────────────────────────────────────────────────────
function Screen6Confirm({ onNext, onBack, booking, goToStep }) {
  const svc = booking.service || {};
  const doctor = booking.doctor || {};
  const mode = booking.mode || {};

  const confirmRows = [
    {
      key: "Service",
      val: svc.serviceName,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
      ),
    },
    {
      key: "Date & Time",
      val: `${booking.date} · ${booking.slot}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      ),
    },
    {
      key: "Mode",
      val: mode.name,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </svg>
      ),
    },
    {
      key: "Location",
      val: CLINIC_LOCATION,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
          <circle cx="12" cy="9" r="2.5" />
        </svg>
      ),
    },
    {
      key: "Consultation Fee",
      val: `₹${svc.price}`,
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <rect x="2" y="5" width="20" height="14" rx="2" />
          <path d="M2 10h20" />
        </svg>
      ),
      isFee: true,
    },
  ];

  const summaryRows = [
    { key: "DOCTOR", val: doctor.fullName || "—" },
    { key: "SPECIALITY", val: svc.specialityName || "—" },
    { key: "DURATION", val: svc.duration ? `${svc.duration} mins` : "—" },
  ];

  return (
    <>
      <Header step={6} />
      <div className={styles.body}>
        <div className={styles.confirmLeft}>
          <div className={styles.confirmTitleRow}>
            <div className={styles.confirmCheckBadge}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className={styles.screenTitle}>Confirm Details</h2>
          </div>
          <p className={styles.screenSub}>Please review your appointment details before proceeding.</p>
        </div>

        <div className={styles.confirmTwoCol}>
          <div>
            <div className={styles.confirmDocCard}>
              <div className={styles.confirmDocAvatarWrap}>
                <span className={styles.confirmDocEmoji}>👩‍⚕️</span>
              </div>
              <div>
                <div className={styles.confirmDocName}>{doctor.fullName || "—"}</div>
                <div className={styles.confirmDocTitle}>{doctor.speciality?.specialityName || "—"}</div>
              </div>
            </div>

            <div className={styles.confirmRowsBox}>
              {confirmRows.map((r, i) => (
                <div
                  key={r.key}
                  className={`${styles.confirmDetailRow} ${
                    i < confirmRows.length - 1 ? styles.confirmDetailRowBorder : ""
                  }`}
                >
                  <div className={styles.confirmDetailLeft}>
                    <span className={r.isFee ? styles.confirmDetailIconFee : styles.confirmDetailIcon}>{r.icon}</span>
                    <span className={styles.confirmDetailKey}>{r.key}</span>
                  </div>
                  <span className={r.isFee ? styles.confirmDetailValFee : styles.confirmDetailVal}>{r.val}</span>
                </div>
              ))}
            </div>

            <div className={styles.editBtnWrap}>
              <button className={styles.editDetailsBtn} onClick={() => goToStep(0)}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                  <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Edit Details
              </button>
            </div>
          </div>

          <div className={styles.confirmSummaryPanel}>
            <div className={styles.confirmSummaryHeader}>
              <span className={styles.confirmSummaryTitle}>Appointment Summary</span>
              <div className={styles.confirmSummaryIllo}>📋</div>
            </div>

            {summaryRows.map((r, i) => (
              <div
                key={r.key}
                className={`${styles.confirmSummaryRow} ${
                  i < summaryRows.length - 1 ? styles.confirmSummaryRowBorder : ""
                }`}
              >
                <div className={styles.confirmSummaryRowLeft}>
                  <span className={styles.confirmSummaryKey}>{r.key}</span>
                </div>
                <span className={styles.confirmSummaryVal}>{r.val}</span>
              </div>
            ))}

            <div className={styles.confirmSummaryFeeRow}>
              <div className={styles.confirmSummaryRowLeft}>
                <span className={styles.confirmSummaryKey}>FEE</span>
              </div>
              <span className={styles.confirmSummaryFeeVal}>₹{svc.price}</span>
            </div>
          </div>
        </div>

        <div className={styles.confirmNavRow}>
          <button className={styles.btnOutline} onClick={onBack}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <button className={styles.btnPrimaryLarge} onClick={onNext}>
            Continue
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8l4 4-4 4M8 12h8" />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 7 — Patient Details (send OTP, or skip if verified)
// ─────────────────────────────────────────────────────────
function Screen7PatientDetails({ onNext, onBack, booking, setBooking, notify }) {
  const [fullName, setFullName] = useState(booking.patient?.fullName || "");
  const [mobile, setMobile] = useState(booking.patient?.mobile || "");
  const [nameErr, setNameErr] = useState("");
  const [mobErr, setMobErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiErr, setApiErr] = useState("");

  const { user } = useAuth();

  useEffect(() => {
    if (user?.fullName && !fullName) setFullName(user.fullName);
    if (user?.mobile && !mobile) setMobile(user.mobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const isVerified = isMobileVerified(mobile || user?.mobile || "");

  async function handleSendOtp() {
    let ok = true;
    if (!fullName.trim()) {
      setNameErr("Full name is required");
      ok = false;
    } else setNameErr("");
    if (!/^\d{10}$/.test(mobile.trim())) {
      setMobErr("Enter a valid 10-digit mobile number");
      ok = false;
    } else setMobErr("");
    if (!ok) return;

    const patient = { fullName: fullName.trim(), mobile: mobile.trim() };

    // Already verified — skip OTP entirely, same as the existing flow.
    if (isVerified) {
      setBooking((b) => ({ ...b, patient: { ...patient, skipOtp: true } }));
      onNext(true);
      return;
    }

    setLoading(true);
    setApiErr("");
    try {
      const res = await sendQuickOtp({ fullName: patient.fullName, mobileNumber: patient.mobile });
      if (res.success) {
        notify("success", "OTP sent successfully! Please verify to confirm your appointment.");
        setBooking((b) => ({ ...b, patient: { ...patient, skipOtp: false } }));
        onNext(false);
      } else {
        notify("error", res.message || "Failed to send OTP. Please try again.");
      }
    } catch (err) {
      setApiErr(err?.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Header step={7} />
      <div className={styles.body}>
        <div>
          <h2 className={styles.screenTitle}>Your Details</h2>
          <p className={styles.screenSub}>We need a few details to confirm your appointment.</p>
        </div>

        <div className={styles.twoCol}>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <label className="ava-text-xs" style={{ color: "#374151" }}>
                Full Name
              </label>
              <input
                type="text"
                placeholder="Full Name"
                value={fullName}
                onChange={(e) => {
                  setFullName(e.target.value);
                  setNameErr("");
                }}
                className="w-full px-4 py-3 text-sm rounded-xl outline-none transition-colors"
                style={{
                  border: nameErr ? "1.5px solid var(--ava-color-error-base)" : "1.5px solid #e5e7eb",
                  backgroundColor: "#fff",
                }}
              />
              {nameErr && (
                <p className="ava-text-xs" style={{ color: "var(--ava-color-error-base)" }}>
                  {nameErr}
                </p>
              )}
            </div>

            <div className="flex flex-col gap-1">
              <label className="ava-text-xs" style={{ color: "#374151" }}>
                Mobile Number
              </label>
              <div
                className="flex rounded-xl overflow-hidden"
                style={{ border: mobErr ? "1.5px solid var(--ava-color-error-base)" : "1.5px solid #e5e7eb" }}
              >
                <div
                  className="flex items-center px-3 py-3 flex-shrink-0"
                  style={{ backgroundColor: "#f3f4f6", borderRight: "1.5px solid #e5e7eb" }}
                >
                  <span className="ava-text-sm" style={{ color: "#374151" }}>
                    +91
                  </span>
                </div>
                <input
                  type="tel"
                  placeholder="Enter 10-digit mobile number"
                  value={mobile}
                  maxLength={10}
                  disabled={isVerified}
                  onChange={(e) => {
                    if (!isVerified) {
                      setMobile(e.target.value.replace(/\D/g, ""));
                      setMobErr("");
                    }
                  }}
                  className="flex-1 min-w-0 px-3 py-3 text-sm outline-none bg-white"
                  style={{
                    border: "none",
                    backgroundColor: isVerified ? "#f3f4f6" : "#fff",
                    color: isVerified ? "#6b7280" : "inherit",
                    cursor: isVerified ? "not-allowed" : "text",
                  }}
                />
              </div>
              {mobErr && (
                <p className="ava-text-xs" style={{ color: "var(--ava-color-error-base)" }}>
                  {mobErr}
                </p>
              )}
              <p className="ava-text-caption mt-0.5">
                {isVerified ? "Your mobile number is already verified." : "An OTP will be sent to this number for verification."}
              </p>
              {apiErr && (
                <p className="ava-text-xs mt-1" style={{ color: "var(--ava-color-error-base)" }}>
                  {apiErr}
                </p>
              )}
            </div>
          </div>

          <div className={styles.sidePanel}>
            <div className={styles.sidePanelTitle}>Appointment Summary</div>
            <div className={styles.ctxRow}>
              <div className={styles.ctxKey}>Service</div>
              <div className={styles.ctxVal}>{booking.service?.serviceName}</div>
            </div>
            <div className={styles.ctxRow}>
              <div className={styles.ctxKey}>Doctor</div>
              <div className={styles.ctxVal}>{booking.doctor?.fullName}</div>
            </div>
            <div className={styles.ctxRow}>
              <div className={styles.ctxKey}>Date &amp; Time</div>
              <div className={styles.ctxVal}>
                {booking.date} · {booking.slot}
              </div>
            </div>
          </div>
        </div>

        <NavRow onBack={onBack} onNext={handleSendOtp} disabled={loading} nextLabel={loading ? "Sending OTP…" : isVerified ? "Continue" : "Send OTP"} />
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 8 — OTP Verification (only shown if not pre-verified)
// ─────────────────────────────────────────────────────────
function Screen8OTP({ onNext, onBack, booking, notify }) {
  const patient = booking.patient || {};
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const [error, setError] = useState("");
  const [resent, setResent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const inputRefs = useRef([]);

  useEffect(() => {
    if (countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  function handleChange(index, value) {
    if (!/^\d?$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);
    setError("");
    if (value && index < OTP_LENGTH - 1) inputRefs.current[index + 1]?.focus();
  }

  function handleKeyDown(index, e) {
    if (e.key === "Backspace" && !otp[index] && index > 0) inputRefs.current[index - 1]?.focus();
  }

  function handlePaste(e) {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, OTP_LENGTH).split("");
    const updated = [...otp];
    pasted.forEach((d, i) => (updated[i] = d));
    setOtp(updated);
    inputRefs.current[Math.min(pasted.length, OTP_LENGTH - 1)]?.focus();
  }

  async function handleVerify(e) {
    e.preventDefault();
    if (loading) return;
    const code = otp.join("");
    if (code.length < OTP_LENGTH) {
      setError(`Please enter all ${OTP_LENGTH} digits`);
      return;
    }
    setLoading(true);
    setError("");
    try {
      const verifyResponse = await verifyOtp({ fullName: patient.fullName, mobileNumber: patient.mobile, otp: code });
      if (!verifyResponse?.success) {
        setError(verifyResponse?.message || "Invalid OTP. Please try again.");
        return;
      }
      const registerResponse = await quickRegister({
        fullName: patient.fullName,
        mobileNumber: patient.mobile,
        otp: code,
        orgName: "FemCare",
      });
      storePatientSession({
        ...registerResponse.data,
        fullName: patient.fullName,
        mobile: patient.mobile,
        isVerified: true,
      });
      notify?.("success", "OTP verified successfully");
      onNext();
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  async function handleResend() {
    if (countdown > 0) return;
    try {
      setOtp(Array(OTP_LENGTH).fill(""));
      setError("");
      setResent(false);
      setCountdown(60);
      await sendQuickOtp({ fullName: patient.fullName, mobileNumber: patient.mobile });
      setResent(true);
      setTimeout(() => setResent(false), 3000);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to resend OTP");
    }
  }

  return (
    <>
      <Header step={7} />
      <div className={styles.body}>
        <div>
          <h2 className={styles.screenTitle}>Verify OTP</h2>
          <p className={styles.screenSub}>
            We sent a {OTP_LENGTH}-digit OTP to <strong>+91 {patient.mobile}</strong>
          </p>
        </div>

        <form onSubmit={handleVerify} className="flex flex-col items-center gap-4 py-4">
          <div className="flex flex-wrap gap-2 justify-center" onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="tel"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="text-center font-bold text-lg rounded-xl outline-none transition-all"
                style={{
                  width: 44,
                  height: 52,
                  border: digit
                    ? "2px solid var(--ava-color-secondary-500)"
                    : error
                    ? "2px solid var(--ava-color-error-base)"
                    : "2px solid #e5e7eb",
                  backgroundColor: digit ? "var(--ava-color-secondary-50)" : "#fff",
                  color: "#1a1a1a",
                }}
              />
            ))}
          </div>

          {error && (
            <p className="ava-text-xs text-center" style={{ color: "var(--ava-color-error-base)" }}>
              {error}
            </p>
          )}
          {resent && (
            <p className="ava-text-xs text-center" style={{ color: "#22c55e" }}>
              OTP resent successfully!
            </p>
          )}

          <p className="ava-text-xs" style={{ color: "var(--text-light)" }}>
            Didn't receive it?{" "}
            {countdown > 0 ? (
              <span style={{ color: "#9ca3af" }}>
                Resend in <strong style={{ color: "var(--primary-color)" }}>{countdown}s</strong>
              </span>
            ) : (
              <button
                type="button"
                onClick={handleResend}
                className="cursor-pointer"
                style={{ color: "var(--primary-color)", background: "none", border: "none" }}
              >
                Resend OTP
              </button>
            )}
          </p>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl ava-text-sm transition-opacity hover:opacity-90 cursor-pointer"
            style={{
              backgroundColor: loading ? "#9ca3af" : "var(--primary-color)",
              color: "#fff",
              border: "none",
              cursor: loading ? "wait" : "pointer",
            }}
          >
            {loading ? "Verifying..." : "Confirm & Continue"}
          </button>
        </form>

        <div className={styles.navRow}>
          <button className={styles.btnOutline} onClick={onBack}>
            <ArrowLeft /> Back
          </button>
        </div>
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 9 — Payment
// ─────────────────────────────────────────────────────────
function Screen9Payment({ onBack, onClose, booking, onDone, notify }) {
  const [paymentChoice, setPaymentChoice] = useState("pay_now");
  const [loading, setLoading] = useState(false);
  const [apiErr, setApiErr] = useState("");
  const svc = booking.service || {};
  const doctor = booking.doctor || {};
  const isPayNow = paymentChoice === "pay_now";

  async function handlePay() {
    setLoading(true);
    setApiErr("");
    try {
      const raw = JSON.parse(localStorage.getItem("patientPersona") || "{}");
      const patientId = raw.patientId;

      const res = await fetch(`${API_ROOT}/book-an-appointment/appointment/book`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clinicId: BOOKING_CLINIC_ID,
          providerId: booking.doctorId,
          patientId,
          slotId: booking.slotId,
          appointmentDate: booking.slotDate,
          appointmentType: (booking.mode?.name || "").toLowerCase().includes("video") ? "VIRTUAL" : "IN_PERSON",
          paymentOption: isPayNow ? "PAY_NOW" : "PAY_LATER",
          amount: String(svc.price ?? ""),
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.message || "Booking failed");
      }

      onDone({ paymentStatus: isPayNow ? "paid" : "pending" });
    } catch (err) {
      setApiErr(err.message || "Something went wrong. Please try again.");
      notify?.("error", err.message || "Booking failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <Header step={8} />
      <div className={styles.body}>
        <div className={styles.twoCol} style={{ gridTemplateColumns: "1fr 280px" }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div className={styles.optionIcon} style={{ background: "var(--plum-s)", flexShrink: 0 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--plum-m)" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
              </div>
              <div>
                <h2 className={styles.screenTitle} style={{ marginBottom: 2 }}>
                  Complete Your Payment
                </h2>
                <p className={styles.screenSub} style={{ marginBottom: 0 }}>
                  Secure your appointment by completing the payment.
                </p>
              </div>
            </div>

            <div
              style={{
                background: "var(--plum-d)",
                borderRadius: "var(--radius)",
                padding: "18px 22px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 22,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                <div
                  style={{
                    width: 42,
                    height: 42,
                    background: "rgba(255,255,255,0.15)",
                    borderRadius: "var(--radius-sm)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                    <rect x="2" y="5" width="20" height="14" rx="2" />
                    <path d="M2 10h20" />
                  </svg>
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#fff" }}>Amount Payable</div>
                  <div style={{ fontSize: 11, color: "rgba(255,255,255,0.65)", marginTop: 2 }}>{svc.serviceName}</div>
                </div>
              </div>
              <div style={{ fontSize: 30, fontWeight: 800, color: "#fff", letterSpacing: -1 }}>₹{svc.price}</div>
            </div>

            <div className={styles.payMethodsLabel}>Payment Option</div>
            {[
              { id: "pay_now", label: "Pay Now", sub: "Secure online payment" },
              { id: "pay_later", label: "Pay Later", sub: "Pay at the clinic" },
            ].map((choice) => {
              const isSelected = paymentChoice === choice.id;
              return (
                <div
                  key={choice.id}
                  className={`${styles.payMethod} ${isSelected ? styles.selected : ""}`}
                  onClick={() => setPaymentChoice(choice.id)}
                >
                  <div className={styles.payMethodText} style={{ flex: 1 }}>
                    <strong>{choice.label}</strong>
                    <span>{choice.sub}</span>
                  </div>
                  <Radio checked={isSelected} />
                </div>
              );
            })}

            {apiErr && (
              <p className="ava-text-xs mt-2" style={{ color: "var(--ava-color-error-base)" }}>
                {apiErr}
              </p>
            )}
          </div>

          <div className={styles.payIllo} style={{ padding: 20 }}>
            <div className={styles.sidePanelTitle}>Appointment Summary</div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: "9px 0",
                borderBottom: "1px solid var(--border)",
              }}
            >
              <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{booking.date || "—"}</span>
              <div style={{ width: 1, height: 18, background: "var(--border)", flexShrink: 0 }} />
              <span style={{ fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{booking.slot || "—"}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 0",
                borderBottom: "1px solid var(--border)",
                marginBottom: 4,
              }}
            >
              <div className={styles.confirmDocAvatar}>👩‍⚕️</div>
              <div>
                <div className={styles.confirmDocName}>{doctor.fullName || "—"}</div>
                <div className={styles.confirmDocTitle}>{doctor.speciality?.specialityName || "—"}</div>
                <div style={{ fontSize: 11, color: "var(--muted)", marginTop: 1 }}>{CLINIC_LOCATION}</div>
              </div>
            </div>

            <hr className={styles.summaryDivider} />
            <div className={styles.sidePanelTitle} style={{ marginBottom: 10 }}>
              Payment Details
            </div>
            <div className={styles.summaryRow}>
              <span className={styles.summaryKey}>Consultation Fee</span>
              <span className={styles.summaryVal}>₹{svc.price}</span>
            </div>
            <div
              className={styles.summaryRow}
              style={{ borderTop: "1px solid var(--plum-b)", paddingTop: 8, marginTop: 4 }}
            >
              <span style={{ fontSize: 13, fontWeight: 800, color: "var(--plum-d)" }}>Total Amount</span>
              <span style={{ fontSize: 15, fontWeight: 800, color: "var(--plum-d)" }}>₹{svc.price}</span>
            </div>
          </div>
        </div>

        <div className={`${styles.navRow} ${styles.navRowSpaced}`}>
          <button className={styles.btnOutline} onClick={onBack}>
            <ArrowLeft /> Back
          </button>
          <button
            className={`btn-primary ${styles.btnPrimary}`}
            onClick={handlePay}
            disabled={loading}
            style={{ padding: "12px 28px", fontSize: 14 }}
          >
            {loading ? (isPayNow ? "Processing…" : "Confirming…") : isPayNow ? `Pay ₹${svc.price} Securely` : "Confirm Booking"}
            <ArrowRight />
          </button>
        </div>
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  SCREEN 10 — Appointment Confirmed
// ─────────────────────────────────────────────────────────
function Screen10Confirmed({ booking, paymentStatus }) {
  const svc = booking.service || {};
  const doctor = booking.doctor || {};
  const mode = booking.mode || {};
  const aptId = `APT-${Math.floor(10000000 + Math.random() * 90000000)}`;

  const aptRows = [
    { key: "Service", val: svc.serviceName },
    { key: "Doctor", val: doctor.fullName },
    { key: "Date & Time", val: `${booking.date} · ${booking.slot}` },
    { key: "Mode", val: mode.name },
    { key: "Location", val: CLINIC_LOCATION },
    { key: "Payment", val: paymentStatus === "paid" ? "Paid" : "Pending at clinic" },
  ];

  return (
    <>
      <Header step={8} />
      <div className={styles.body}>
        <div className={styles.confirmCenter}>
          <div className={styles.confirmCheck}>✓</div>
          <h2 className={styles.confirmHeadline}>Appointment Confirmed!</h2>
          <p className={styles.confirmDesc}>Your appointment has been booked successfully.</p>

          <div className={styles.confirmAptCard}>
            <div className={styles.confirmAptId}>📋 {aptId}</div>
            {aptRows.map((r) => (
              <div key={r.key} className={styles.confirmAptRow}>
                <span className={styles.carKey}>{r.key}</span>
                <span className={styles.carVal}>{r.val}</span>
              </div>
            ))}
          </div>

          <div className={styles.confirmSms}>✅ A confirmation email &amp; SMS has been sent to you.</div>

          <div className={styles.confirmActions}>
            <a href="/" className={`btn-primary ${styles.btnPrimary}`}>
              Go to Dashboard
            </a>
            <button className={styles.btnSecondary}>📅 Add to Calendar</button>
          </div>
        </div>
      </div>
    </>
  );
}

// ─────────────────────────────────────────────────────────
//  ORCHESTRATOR
// ─────────────────────────────────────────────────────────
export default function BookingFlow() {
  const [step, setStep] = useState(0);
  const [booking, setBooking] = useState({});
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [notif, setNotif] = useState(null);
  const notify = (type, message) => setNotif({ type, message });

  const next = () => setStep((s) => s + 1);
  const back = () => setStep((s) => Math.max(0, s - 1));
  const goToStep = (s) => setStep(s);

  // Step indices are dynamic: after Patient Details (index 6),
  // we insert the OTP screen only if it's actually required.
  const needsOtp = booking.patient && booking.patient.skipOtp === false;

  function renderScreen() {
    switch (step) {
      case 0:
        return <Screen1TypeSelect onNext={next} booking={booking} setBooking={setBooking} />;
      case 1:
        return <Screen2ServiceSelect onNext={next} onBack={back} booking={booking} setBooking={setBooking} />;
      case 2:
        return <Screen3ProviderSelect onNext={next} onBack={back} booking={booking} setBooking={setBooking} />;
      case 3:
        return <Screen4ModeSelect onNext={next} onBack={back} booking={booking} setBooking={setBooking} />;
      case 4:
        return <Screen5DateSlot onNext={next} onBack={back} booking={booking} setBooking={setBooking} />;
      case 5:
        return <Screen6Confirm onNext={next} onBack={back} booking={booking} goToStep={goToStep} />;
      case 6:
        return (
          <Screen7PatientDetails
            booking={booking}
            setBooking={setBooking}
            onBack={back}
            notify={notify}
            onNext={(skipOtp) => setStep(skipOtp ? 8 : 7)}
          />
        );
      case 7:
        return (
          <Screen8OTP
            booking={booking}
            onBack={() => setStep(6)}
            notify={notify}
            onNext={() => setStep(8)}
          />
        );
      case 8:
        return (
          <Screen9Payment
            booking={booking}
            onBack={() => setStep(needsOtp ? 7 : 6)}
            notify={notify}
            onDone={({ paymentStatus: ps }) => {
              setPaymentStatus(ps);
              setStep(9);
            }}
          />
        );
      case 9:
        return <Screen10Confirmed booking={booking} paymentStatus={paymentStatus} />;
      default:
        return null;
    }
  }

  return (
    <>
      <DigitalHealthFAB />
      {notif && <Notification type={notif.type} message={notif.message} onClose={() => setNotif(null)} />}
      <div className={styles.page}>
        <div className={styles.card}>{renderScreen()}</div>
      </div>
    </>
  );
}
